import { type TDict } from './types';

/**
 * Мержит новый additional с существующим из RUM.
 * Новые поля перезаписывают существующие.
 *
 * @param varsList - массив переменных из window.Ya.Rum.getVarsList()
 * @param newAdditional - новый additional (объект)
 * @returns смерженный additional как JSON-строка
 */
export function mergeAdditional(varsList: string[], newAdditional: TDict): string {
    const existingEntry = varsList.find(item => item.startsWith('-additional='));

    if (!existingEntry) {
        return JSON.stringify(newAdditional);
    }

    try {
        const encodedValue = existingEntry.substring('-additional='.length);
        const decodedValue = decodeURIComponent(encodedValue);
        const existingObj = JSON.parse(decodedValue);
        const merged = { ...existingObj, ...newAdditional };

        return JSON.stringify(merged);
    } catch {
        return JSON.stringify(newAdditional);
    }
}

/**
 * Удаляет старый -additional из массива переменных RUM
 */
export function removeOldAdditional(varsList: string[]): void {
    const index = varsList.findIndex(item => item.startsWith('-additional='));

    if (index !== -1) {
        varsList.splice(index, 1);
    }
}
